module.exports = __webpack_public_path__ + "img/cuff_length.98d59351.png";